// extracted by mini-css-extract-plugin
export var content = "_ns-1";
export var fullScreen = "_ns-0";